import { FilesAPI } from '../APIs/filesApi';
import { isPhoto, isVideo } from '../models/FileModel';
import { ItemModel, isFolderItem } from '../models/ItemModel';
import { useGet } from './useApi';

export type UseFileTypeReturn = {
    type: 'photo' | 'video' | undefined;
    isPhoto: boolean;
    isVideo: boolean;
};
function fixedType<T extends { [key: string]: UseFileTypeReturn }>(
    input: T
): T {
    return Object.fromEntries(
        Object.entries(input).map(([key, value]) => [key, Object.freeze(value)])
    ) as T;
}
const types = fixedType({
    photo: {
        type: 'photo',
        isPhoto: true,
        isVideo: false,
    },
    video: {
        type: 'video',
        isPhoto: false,
        isVideo: true,
    },
    other: {
        type: undefined,
        isPhoto: false,
        isVideo: false,
    },
});
export function useFileType(
    file: string | ItemModel | undefined
): UseFileTypeReturn {
    const fileData = useGet(
        typeof file === 'string' ? FilesAPI.item(file) : null
    );
    const actualFile =
        fileData.data?.data ?? (typeof file !== 'string' ? file : undefined);
    if (!actualFile) {
        return types.other;
    }
    if (isFolderItem(actualFile)) {
        return types.other;
    }
    if (isPhoto(actualFile)) {
        return types.photo;
    }
    if (isVideo(actualFile)) {
        return types.video;
    }
    return types.other;
}
